module.exports = __webpack_public_path__ + "static/gallery-img-11-1d69237c0f6ce56f11e78e7c4d4a199f.jpg";